import { Columns } from '@shared/interfaces/table/column-config';
import {ConnectionPointDto} from '@app/api/nts';
import { statePartial } from '@shared/partials/state.partial';

export const connectionpointDetailsMasterdata: Columns<ConnectionPointDto>[] = [
  {
    title: 'Tilslutningspunktnummer',
    key: 'identification'
  },
  {
    title: 'Alternativt tilslutningspunktnummer',
    key: 'alternativeIdentification'
  },
  {
    title: 'Stationsnummer',
    key: 'stationNumber'
  },
  statePartial,
  {
    title: 'Kategori',
    key: 'connectionPointCategory.name'
  },
  {
    title: 'Tilslutningsrettighed (kW)',
    key: 'maximumPower'
  },
  {
    title: 'Tilslutningsrettighed (A)',
    key: 'maximumCurrent'
  },
  {
    title: 'Beskrivelse',
    key: 'description'
  }
];
